





















































































































































































































































































import Vue, { PropType } from "vue";

import allDeviceIcon from "../../assets/ApplicationPlan/premium.svg";

import Price from "@/lib/price";
import TextConverter from "@/lib/textConverter";
import Locale from "@/lib/locale";

export interface OffersDebutPlansProps {
  lang: any;
  commonLang: any;
  deviceChoice: any;
  planName: any;
  gradeChoice: any;
  termChoice: any;
  countryChoice: any;
  currencyChoice: any;
  resultPlansMap: any;
  defaultData: any;
  extendParams: any;
  prevUrl: string;
  action: string;
  device_type: string;
  originalPriceMap: any;
  priceMap: any;
  planListUrl: string;
  deviceUseRangeUrl: string;
  gradeDifferenceUrl: string;
  galaxyHelpUrl: string;
  changePlanUrl: string;
  vandleCardUrl: string;
}

export default Vue.extend({
  name: "vc-offers-debut-plans",
  components: {
    allDeviceIcon: allDeviceIcon
  },
  data() {
    return {
      device_type: this.defaultData.device_type,
      grade_type: this.defaultData.grade_type,
      term_type: this.defaultData.term_type,
      country_code: this.defaultData.country_code,
      currency_code: this.defaultData.currency_code,
      originalMonthlyPrice: this.originalPriceMap[
        this.resultPlansMap[this.defaultData.device_type][
          this.defaultData.grade_type
        ]["month"]
      ][this.defaultData.currency_code]["price"],
      monthlyPrice: this.priceMap[
        this.resultPlansMap[this.defaultData.device_type][
          this.defaultData.grade_type
        ]["month"]
      ][this.defaultData.currency_code]["price"],
      monthlyDiscount: this.priceMap[
        this.resultPlansMap[this.defaultData.device_type][
          this.defaultData.grade_type
        ]["month"]
      ][this.defaultData.currency_code]["discount"],
      monthlyDiscountTerm: this.priceMap[
        this.resultPlansMap[this.defaultData.device_type][
          this.defaultData.grade_type
        ]["month"]
      ]["term_num"],
      originalYearlyPrice: this.originalPriceMap[
        this.resultPlansMap[this.defaultData.device_type][
          this.defaultData.grade_type
        ]["year"]
      ][this.defaultData.currency_code]["price"],
      yearlyPrice: this.priceMap[
        this.resultPlansMap[this.defaultData.device_type][
          this.defaultData.grade_type
        ]["year"]
      ][this.defaultData.currency_code]["price"],
      yearlyDiscount: this.priceMap[
        this.resultPlansMap[this.defaultData.device_type][
          this.defaultData.grade_type
        ]["year"]
      ][this.defaultData.currency_code]["discount"],
      locale: Locale.getLocale()
    };
  },
  props: {
    lang: {
      type: Object as PropType<OffersDebutPlansProps["lang"]>,
      default: () => {}
    },
    commonLang: {
      type: Object as PropType<OffersDebutPlansProps["commonLang"]>,
      default: () => {}
    },
    deviceChoice: {
      type: Object as PropType<OffersDebutPlansProps["deviceChoice"]>,
      default: () => {}
    },
    planName: {
      type: Object as PropType<OffersDebutPlansProps["planName"]>,
      default: () => {}
    },
    gradeChoice: {
      type: Object as PropType<OffersDebutPlansProps["gradeChoice"]>,
      default: () => {}
    },
    termChoice: {
      type: Object as PropType<OffersDebutPlansProps["termChoice"]>,
      default: () => {}
    },
    countryChoice: {
      type: Array as PropType<OffersDebutPlansProps["countryChoice"]>,
      default: () => []
    },
    currencyChoice: {
      type: Array as PropType<OffersDebutPlansProps["currencyChoice"]>,
      default: () => {}
    },
    resultPlansMap: {
      type: Object as PropType<OffersDebutPlansProps["resultPlansMap"]>,
      default: () => {}
    },
    defaultData: {
      type: Object as PropType<OffersDebutPlansProps["defaultData"]>,
      default: () => {}
    },
    extendParams: {
      type: Object as PropType<OffersDebutPlansProps["extendParams"]>,
      default: () => {}
    },
    action: {
      type: String as PropType<OffersDebutPlansProps["action"]>,
      default: ""
    },
    prevUrl: {
      type: String as PropType<OffersDebutPlansProps["prevUrl"]>,
      default: ""
    },
    originalPriceMap: {
      type: Object as PropType<OffersDebutPlansProps["originalPriceMap"]>,
      default: () => {}
    },
    priceMap: {
      type: Object as PropType<OffersDebutPlansProps["priceMap"]>,
      default: () => {}
    },
    planListUrl: {
      type: String as PropType<OffersDebutPlansProps["planListUrl"]>,
      default: ""
    },
    deviceUseRangeUrl: {
      type: String as PropType<OffersDebutPlansProps["deviceUseRangeUrl"]>,
      default: ""
    },
    gradeDifferenceUrl: {
      type: String as PropType<OffersDebutPlansProps["gradeDifferenceUrl"]>,
      default: ""
    },
    galaxyHelpUrl: {
      type: String as PropType<OffersDebutPlansProps["galaxyHelpUrl"]>,
      default: ""
    },
    changePlanUrl: {
      type: String as PropType<OffersDebutPlansProps["changePlanUrl"]>,
      default: ""
    },
    vandleCardUrl: {
      type: String as PropType<OffersDebutPlansProps["vandleCardUrl"]>,
      default: ""
    }
  },
  computed: {
    firstCountryList(): Object[] {
      return this.countryChoice.filter(function(country: any) {
        if (country.display_list_priority == 1) return true;
      });
    },
    secondCountryList(): Object[] {
      return this.countryChoice.filter(function(country: any) {
        if (country.display_list_priority == 2) return true;
      });
    },
    entryPaymentMethod(): string {
      return !["JPY", "EUR"].includes(this.currency_code)
        ? this.$props.lang.card_input_next
        : this.$props.lang.proceed_to_purchase;
    }
  },
  methods: {
    submitPlan() {
      const formElement = this.$refs.formOffers as HTMLFormElement;
      const inputPlan = document.createElement("input");
      inputPlan.setAttribute("type", "hidden");
      inputPlan.setAttribute("name", "plan_code");
      inputPlan.setAttribute(
        "value",
        this.resultPlansMap[this.device_type][this.grade_type][this.term_type]
      );
      formElement.appendChild(inputPlan);
      formElement.submit();
    },
    changePrice() {
      this.monthlyPrice = this.priceMap[
        this.resultPlansMap[this.device_type][this.grade_type]["month"]
      ][this.currency_code]["price"];
      this.monthlyDiscount = this.priceMap[
        this.resultPlansMap[this.device_type][this.grade_type]["month"]
      ][this.currency_code]["discount"];
      this.originalMonthlyPrice = this.originalPriceMap[
        this.resultPlansMap[this.device_type][this.grade_type]["month"]
      ][this.currency_code]["price"];

      this.yearlyPrice = this.priceMap[
        this.resultPlansMap[this.device_type][this.grade_type]["year"]
      ][this.currency_code]["price"];
      this.yearlyDiscount = this.priceMap[
        this.resultPlansMap[this.device_type][this.grade_type]["year"]
      ][this.currency_code]["discount"];
      this.originalYearlyPrice = this.originalPriceMap[
        this.resultPlansMap[this.device_type][this.grade_type]["year"]
      ][this.currency_code]["price"];
    },
    displayDiscountRate(lang: string) {
      return this.lang["discount_rate"].replace(":discount", lang);
    },
    displayDiscountRateWithMonthlyTerm(month: string, discount: string) {
      return this.lang["discount_rate_with_month_period"]
        .replace(":month", month)
        .replace(":discount", Math.floor(Number(discount)));
    },
    displayDiscountRateWithYearlyTerm(discount: string) {
      return this.lang["discount_rate_with_year_period"].replace(
        ":discount",
        Math.floor(Number(discount))
      );
    },
    displayOriginalPrice(price: string) {
      const displayPrice = Price.getPrice(this.currency_code, Number(price));
      return this.lang["discount_original_price"].replace(
        ":original_price",
        displayPrice
      );
    },
    replaceBr(text: string) {
      return TextConverter.replaceBr(text);
    }
  }
});
